// The contact and demo forms' error handling. The API says why it refused a form ("Please
// check your email address.", a failed captcha); show that so the visitor can fix it, not only
// "try again" (CAM-722).
export function formErrorMessage(e) {
  return (
    (e.response && e.response.data && e.response.data.error_message) ||
    'There was an error when trying to contact us. Please try again soon.'
  );
}
